import React from 'react';

export const MythicIcon = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5515 6.11392C11.5515 3.28837 9.32826 0.970409 6.53991 0.818129V0.225952C9.6599 0.378224 12.1403 2.95675 12.1403 6.11392C12.1403 7.0851 11.9068 7.99875 11.494 8.80412L10.9796 8.50634C11.3451 7.78895 11.5515 6.97343 11.5515 6.11392Z"
        fill="white"
      />
      <path
        d="M1.51151 8.50971C1.14605 7.78893 0.939643 6.9768 0.939643 6.11729C0.939643 3.29174 3.16287 0.973779 5.95123 0.821499V0.229322C2.83124 0.381594 0.35083 2.96012 0.35083 6.11729C0.35083 7.08509 0.584327 7.99874 0.99715 8.80749L1.51151 8.50971Z"
        fill="white"
      />
      <path
        d="M6.2456 3.16992L7.7616 1.65394C9.62274 2.28673 10.9628 4.04636 10.9662 6.11729C10.9662 8.62138 9.00687 10.672 6.54338 10.8243V9.63992C8.35715 9.49104 9.78518 7.96828 9.78518 6.11729C9.78518 4.84157 9.10164 3.68766 8.02555 3.06164L6.24897 4.83818L4.47242 3.06164C3.3997 3.68427 2.71279 4.84157 2.71279 6.11729C2.71279 7.96828 4.14079 9.49104 5.95459 9.63992V10.8243C3.49107 10.672 1.53179 8.61799 1.53179 6.11729C1.53179 4.04973 2.87183 2.28673 4.7296 1.65394L6.2456 3.16992Z"
        fill="white"
      />
      <path
        d="M7.25414 4.66562L8.09336 3.82303C8.78027 4.37799 9.19313 5.22058 9.19313 6.11731C9.19313 7.74157 7.87 9.06467 6.24573 9.06467C4.62146 9.06467 3.29833 7.74157 3.29833 6.11731C3.29833 5.22058 3.71115 4.37799 4.3981 3.82303L5.24069 4.66562C4.7805 4.98371 4.47932 5.51497 4.47932 6.11731C4.47932 7.09187 5.26778 7.88708 6.24573 7.88708C7.22368 7.88708 8.0155 7.09187 8.0155 6.11731C8.0155 5.51836 7.71436 4.98371 7.25414 4.66562Z"
        fill="white"
      />
      <path
        d="M10.6853 9.02069C9.73785 10.4656 8.10003 11.4232 6.24566 11.4232C4.39126 11.4232 2.75682 10.4656 1.80595 9.02069L1.29159 9.31847C2.34059 10.9393 4.16791 12.0154 6.24226 12.0154C8.31999 12.0154 10.1439 10.9427 11.1929 9.31847L10.6853 9.02069Z"
        fill="white"
      />
      <path
        d="M7.12888 6.11731C7.12888 6.60508 6.73346 7.0005 6.2457 7.0005C5.7579 7.0005 5.36248 6.60508 5.36248 6.11731C5.36248 5.62953 5.7579 5.23411 6.2457 5.23411C6.73346 5.23411 7.12888 5.62953 7.12888 6.11731Z"
        fill="white"
      />
    </svg>
  );
};

export const NewMythicIcon = () => (
  <img src="assets/Point.png" alt="point mp" id="marker-event" />
);
